module.exports = __webpack_public_path__ + "static/media/CaiShensFortune.02b62fbc.png";